var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginOk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_14400",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 14400",
    transform: "translate(-310 -9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_13915",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 13915",
    transform: "translate(309.246 8.247)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_138",
    "data-name": "\\u6955\\u5186\\u5F62 138",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(0.753 0.753)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_13916",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 13916",
    transform: "translate(314 14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_3845",
    "data-name": "\\u30D1\\u30B9 3845",
    d: "M285.667,15.819l-3.388-3.388.7-.7,2.692,2.692,4.993-4.994.7.7Z",
    transform: "translate(-281.278 -8.033)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginOk);
export default __webpack_public_path__ + "static/media/login-ok.66e99c8c1210b05d451d94f5ab977e23.svg";
export { ForwardRef as ReactComponent };